import { useFormik } from 'formik'
import { PageTitle } from '../../../_metronic/layout/core'
import * as Yup from 'yup'
import { Col, Form, Row, Toast, ToastContainer } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { locationListApi, getLowestPriceOffersForAllProductGroups } from './_request'
import { checkDisplayValue } from '../../utils/utils'
import { KTCardBody, KTSVG, showToast } from '../../../_metronic/helpers'
import { OffersListLoading } from '../offer-management/offers-list/components/loading/OffersListLoading'
import download from 'downloadjs'
import axios from 'axios'
import { SERVER_URL } from '../../ServerConfig'
import { useIntl } from 'react-intl'
import { ToastType } from '../../../_metronic/helpers/crud-helper/ToastTypes'
import moment from 'moment'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { checkPermission } from '../../utils/checkPermission';

const AllOffersWithPrice = () => {
  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })
  const [loading, setLoading] = useState(false);
  // Remove productGroupList and selectedProductGroupList state
  const [locationList, setLocationList] = useState<any>([])
  const [selectedLocationList, setSelectedLocationList] = useState<any>(null)
  const [offerDetail, setOfferDetail] = useState<any>([])
  const [offerPrice, setOfferPrice] = useState<any>([])
  const [getCityData, setCityData] = useState<any>()
  const intl = useIntl()
  
  const offerValidation = Yup.object().shape({
    destination_location_id: Yup.string()
      .required('Location is required'),
    quantity: Yup.string()
      .required('Quantity is required'),
  })


  const formik = useFormik({
    initialValues: {
      destination_location_id: '',
      quantity: '25',
    },
    validationSchema: offerValidation,
    onSubmit: async (values: any) => {
      // Use only the new API for lowest price offers
      setOfferPrice([])
      setOfferDetail([])
      try {
        const data = await getLowestPriceOffersForAllProductGroups(values.destination_location_id, values.quantity)
        // If the API returns an array, set it directly. If wrapped in a property, adjust accordingly.
        if (Array.isArray(data)) {
          setOfferPrice(data)
        } else if (data?.responseData) {
          setOfferPrice(data.responseData)
        } else if (data?.data) {
          setOfferPrice(data.data)
        } else {
          setOfferPrice([])
        }
      } catch (err: any) {
        setOfferPrice([])
        let message = err?.message
          ? err.message
          : err?.responseMessage
            ? err.responseMessage
            : ('Something went wrong' as any)
        setSessionMessage({ type: 'error', message: message, show: true })
      }
    },
  });

  useEffect(() => {
    if (sessionMessage.show) {
      setTimeout(() => {
        setSessionMessage({
          type: '',
          message: '',
          show: false,
        })
      }, 5000)
    }
  }, [sessionMessage.message])

  const getLocationList = async (search: any) => {
    try {
      let { responseStatus, responseData, responseMessage } = await locationListApi(search) as any
      if (responseStatus == 200 && responseData) {
        setLocationList(
          responseData.map((x: any) => {
            x.label = x.name
            x.value = x.id
            setCityData(x?.name)
            return x
          })
        )
      } else {
        let message = responseMessage ? responseMessage : 'Something went wrong'
        setSessionMessage({ type: 'error', message: message, show: true })
      }
    } catch (err: any) {
      let message = err?.message
        ? err.message
        : err?.responseMessage
          ? err.responseMessage
          : ('Something went wrong' as any)
      setSessionMessage({ type: 'error', message: message, show: true })
    }
  }



  const handleCopy = (row: any) => {
    // Remove product group from copied text
    const locationLabel = locationList.find((x: any) => x.value === formik.values.destination_location_id)?.label ?? '-';

    const textToCopy = `  Grade :- *${row.product_variation} @ ${row.totalPrice}/-kg*\n  Rate: for total ${formik.values.quantity} MT.\n  Supply: Delivered\n  Payment Terms: Pay on Delivery\n  Location: ${locationLabel}\n  Subject to unsold\n  To confirm order reply with *confirm* .`;

    navigator.clipboard.writeText(textToCopy).then(() => {
      showToast({ message: 'Copied to clipboard!', autoClose: 1000 });
    });
  };
  useEffect(() => {
    // Remove getProductGroupList
    getLocationList('')
    console.log("offerDetail", offerPrice);

  }, [])

  return (
    <>
      {checkPermission('Lowest Price Offers For All Product Groups', 'list') ? (
        <>
          <div className="d-flex justify-content-between align-items-center">
            <div className="fw-bold fs-2">Lowest Offer With Price</div>
          </div>
          <div className='card card-body p-12 mt-10'>
            <div className="offer-form-wrapper">
              <div className="offer-form-card">
               
                <form className="offer-form" onSubmit={formik.handleSubmit} noValidate>
                  <Row className="justify-content-center align-items-end mb-0" style={{ position: 'relative', zIndex: 99 }}>
                    <Col xs={12} md={5} className="mb-3 mb-md-0">
                      <Form.Group>
                        <Form.Label className="fw-bold required form-label">Location</Form.Label>
                        <Select
                          options={locationList}
                          className="custom_select zIndex-99"
                          classNamePrefix="Select"
                          placeholder="Select Location"
                          value={locationList.find((x: any) => x.value === formik.values.destination_location_id) || null}
                          onChange={(e: any) => {
                            formik.setFieldValue('destination_location_id', e.value)
                            setSelectedLocationList(e)
                          }}
                          styles={{
                            menu: (provided: any) => ({
                              ...provided,
                              zIndex: 9999
                            })
                          }}
                        />
                        {formik.touched.destination_location_id && typeof formik.errors.destination_location_id === 'string' && (
                          <div className="text-danger">{formik.errors.destination_location_id}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={5}>
                      <Form.Group>
                        <Form.Label className="fw-bold required form-label">Quantity</Form.Label>
                        <Form.Control
                          type="text"
                          className="form-control-solid"
                          placeholder="Enter Quantity"
                          value={formik.values.quantity}
                          onChange={(e) => formik.setFieldValue('quantity', e.target.value.trimStart())}
                        />
                        {formik.touched.quantity && typeof formik.errors.quantity === 'string' && (
                          <div className="text-danger">{formik.errors.quantity}</div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mt-3">
                    <Col xs={12} md={5} className="d-flex justify-content-center">
                      <button type="submit" className="btn btn-primary offer-form-btn" disabled={formik.isSubmitting}>
                        {formik.isSubmitting ? "Please Wait..." : "Price"}
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
            <ToastContainer className='p-3' position={'top-end'}>
              <Toast
                show={sessionMessage.show}
                onClose={() => {
                  setSessionMessage({
                    type: '',
                    message: '',
                    show: false,
                  })
                }}
                bg='danger'
              >
                <Toast.Body className='text-white'>{sessionMessage.message}</Toast.Body>
              </Toast>
            </ToastContainer>
            <KTCardBody className='py-4'>
              <div className='offer-with-price-table-container' style={{ position: 'relative', zIndex: 1 }}>
                <table
                  id='kt_table_users'
                  className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer offer-with-price-table'
                >
                  <thead>
                    <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0 bg-light'
                    >
                      <th style={{ width: "20%" }}>
                        Product Group

                      </th>
                      <th style={{ width: "20%" }}>
                        Product Variation
                      </th>
                      <th style={{ width: "15%" }}>
                        MFI
                      </th>
                      <th style={{ width: "10%" }}>
                        Price
                      </th>
                      <th style={{ width: "10%" }}>
                        Offer ID
                      </th>
                      <th style={{ width: "20%" }}>
                        Firm Name
                      </th>
                      <th style={{ width: "20%" }}>
                        Created On / Updated On
                      </th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600 fw-bold'>

                    {offerPrice && offerPrice.length > 0 ? (
                      offerPrice.map((row: any, index: any) => {
                        return (
                          <tr key={index}>
                            {/* <td>{checkDisplayValue(offerDetail.find((x:any)=>x.id == row?.offer_id)?.product_variation)}</td>
                              <td>{checkDisplayValue(offerDetail.find((x:any)=>x.id == row?.offer_id)?.mfi_kvalue)}</td>
                              <td>{checkDisplayValue(row?.totalPrice)}</td>
                              <td>{checkDisplayValue(offerDetail.find((x:any)=>x.id == row?.offer_id)?.offer_number)}</td> */}
                            <td>{checkDisplayValue(row?.product_group_name)}</td>
                            <td>{checkDisplayValue(row?.product_variation)}</td>
                            <td>{checkDisplayValue(row?.mfi_kvalue)}</td>
                            <td>{checkDisplayValue(row?.totalPrice)}</td>
                            <td>{checkDisplayValue(row?.offer_number)}</td>
                            {/* <td className="text-left">
                              <i className="fa-solid fa-copy"
                                style={{ fontSize: '26px', color: 'rgb(13 76 111)' }}
                                onClick={() => handleCopy(row)}>
                              </i>
                            </td> */}
                            <td>{checkDisplayValue(row?.firm_name)}</td>
                            <OverlayTrigger
                              placement='top'
                              overlay={
                                <Tooltip className='py-2 px-2 fs-6'>
                                  {row.updated_at ? 'Updated On' : 'Created On'}
                                </Tooltip>
                              }
                            >
                              <td className="text-nowrap">
                                {row.updated_at || row.created_at
                                  ? moment(row.updated_at || row.created_at).format('hh:mm A MMMM DD, YYYY')
                                  : 'N/A'}
                              </td>
                            </OverlayTrigger>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan={8}>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                            No Offers Found
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>

              </div>

              <Col xl={12}>
                <Col className='justify-content-between'>
                  <div className=' mb-3 mt-3'>Term & Condition</div>
                  <div >
                    <div className='mb-3'>
                      {/* Remove Product Group from Terms */}
                    </div>
                    <div className='mb-3'>
                      Rate: for <strong>{formik.values.quantity ? formik.values.quantity : 0} MT.</strong>
                    </div>

                    <div className='mb-3'>
                      Supply: Delivered
                    </div>

                    <div className='mb-3'>
                      Payment Terms: Pay on Delivery
                    </div>

                    <div className='mb-3'>
                      Location:<strong>{locationList.find((x: any) => x.value === formik.values.destination_location_id)?.label ?? '-'}</strong>
                    </div>

                    <div className='mb-3'>
                      Subject to unsold
                    </div>

                    <div>
                      To confirm order reply with <strong>confirm.</strong>
                    </div>
                  </div>
                </Col>
              </Col>



              {formik.isSubmitting && <OffersListLoading />}
            </KTCardBody>
          </div>



        </>) : ""}
    </>
  )
}
export default AllOffersWithPrice
